// extracted by mini-css-extract-plugin
export default {"root":"SearchBaseComponent_root__WtyMo","header":"SearchBaseComponent_header__-XrWV"};